import React from 'react';
import { createRoot } from 'react-dom/client';

class Uploads extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uploads: props.uploads
    };
    this.addUpload = this.addUpload.bind(this);
  }

  addUpload(upload) {
    var updatedUploads = this.state.uploads.slice()
    updatedUploads.push(upload)
    this.setState({uploads: updatedUploads})
  }

  render() {
    var uploads = this.props.uploads
    return (
      <div>
      <NewUpload onNewUpload={this.addUpload}/>
      </div>
    )
  }
}

class NewUpload extends React.Component {
  render() {
    return (
      <div>
        <label className="file_upload_label control-label">File</label>
        <div className="controls">
          <input type="file" id="attachment" name="requesty_physical_element[verification]" className="file_upload" required />
        </div>
      </div>
    )
  }
}

// Store roots to avoid recreating them
const rootMap = new Map();

window.backgroundUploader = function(id, uploads) {
  const container = document.getElementById(id);
  let root = rootMap.get(id);
  if (!root) {
    root = createRoot(container);
    rootMap.set(id, root);
  }
  root.render(<Uploads uploads={uploads} />);
}
